window.WishlistApi = {
  async getHelper(maxAttempts = 10, delay = 250) {
    let attempts = 0;

    while (attempts < maxAttempts) {
      const helper = window.refactor_apps?.wishlist;

      if (helper) {
        if (typeof helper.ready === "function") {
          await helper.ready();
        }

        if ( typeof helper.getAllLists === "function") {
          return helper;
        }
      }

      await new Promise((resolve) => setTimeout(resolve, delay));
      attempts += 1;
    }

    throw new Error("[WishlistApi] wishlist helper did not expose list API in time");
  },

  validateListId(listId) {
    if (!listId) {
      throw new Error("[WishlistApi] listId is required");
    }
  },

  validateVariantId(variantId) {
    if (!variantId || Number.isNaN(Number(variantId))) {
      throw new Error(`[WishlistApi] invalid variantId: ${variantId}`);
    }
  },

  validateProduct(product) {
    if (!product) {
      throw new Error("[WishlistApi] product is required");
    }

    const id = Number(product.id);
    const variantId = Number(product.variantId);
    const handle = product.handle || "";

    if (!id || !variantId || !handle) {
      throw new Error(
        `[WishlistApi] invalid product payload: id=${id}, variantId=${variantId}, handle=${handle}`
      );
    }
  },

  normalizeProduct(product) {
    return {
      id: Number(product.id),
      variantId: Number(product.variantId),
      handle: product.handle || "",
    };
  },

  async getLists(options = {}) {
    const helper = await this.getHelper();
    return helper.getAllLists(options);
  },

  async getDefaultList() {
    const lists = await this.getLists();
    const defaultList = lists?.[0];

    if (!defaultList?.id) {
      throw new Error("[WishlistApi] no wishlist list found");
    }

    return defaultList;
  },

  async getList(listId, options = {}) {
    this.validateListId(listId);

    const lists = await this.getLists(options);
    const list = lists?.find((item) => item.id === listId);

    if (!list) {
      throw new Error(`[WishlistApi] list not found: ${listId}`);
    }

    return list;
  },

  async isInList(listId, variantId) {
    this.validateListId(listId);
    this.validateVariantId(variantId);

    const helper = await this.getHelper();

    if (typeof helper.hasVariantInList !== "function") {
      throw new Error("[WishlistApi] helper.hasVariantInList is not available");
    }

    return helper.hasVariantInList(listId, Number(variantId));
  },

  async addToList(listId, product) {
    this.validateListId(listId);
    this.validateProduct(product);

    const helper = await this.getHelper();

    if (typeof helper.addProduct !== "function") {
      throw new Error("[WishlistApi] helper.addProduct is not available");
    }

    return helper.addProduct(listId, this.normalizeProduct(product));
  },

  async removeFromList(listId, product) {
    this.validateListId(listId);
    this.validateProduct(product);

    const helper = await this.getHelper();

    if (typeof helper.removeProduct !== "function") {
      throw new Error("[WishlistApi] helper.removeProduct is not available");
    }

    return helper.removeProduct(listId, this.normalizeProduct(product));
  },
};